var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.noLabelSetting)?_c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.label')}},[_c('el-input',{attrs:{"type":"text"},model:{value:(_vm.optionModel.label),callback:function ($$v) {_vm.$set(_vm.optionModel, "label", $$v)},expression:"optionModel.label"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }